import { BackGlyph, CloseGlyph } from "./settingsGlyphs";

export default function SettingsStackHeader({
  eyebrow,
  title,
  status,
  canGoBack,
  onBack,
  onClose,
}) {
  const statusClassName = [
    "lz-settings-header__status",
    status?.tone === "error"
      ? "lz-settings-header__status--error"
      : status?.tone === "success"
        ? "lz-settings-header__status--success"
        : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <header className="lz-settings-header">
      <div className="lz-settings-header__lead">
        {canGoBack ? (
          <button
            type="button"
            onClick={onBack}
            className="lz-settings-header__icon-button"
            aria-label="Go back"
          >
            <BackGlyph />
          </button>
        ) : (
          <div className="lz-settings-header__spacer" aria-hidden="true" />
        )}

        <div className="lz-settings-header__copy">
          {eyebrow ? <p className="lz-settings-header__eyebrow">{eyebrow}</p> : null}
          <h1 className="lz-settings-header__title">{title}</h1>
          {status ? (
            <p aria-live="polite" className={statusClassName}>
              {status.label}
            </p>
          ) : null}
        </div>
      </div>

      <button
        type="button"
        onClick={onClose}
        className="lz-settings-header__icon-button lz-settings-header__close-button"
        aria-label="Close settings"
      >
        <CloseGlyph />
      </button>
    </header>
  );
}
